import consoleLogger from '../../logger/consoleLogger';
import { GameClient } from '../../gameClient/gameClient';
import { OnErrorCommand } from '../../gameClient/clientCommands/onErrorCommand';
import { WebCommands } from '../webCommands';
import { SetFacebookAccessTokenCommand } from '../../gameClient/clientCommands/setFacebookAccessTokenCommand';

import { getFbAdapter } from "../../login/fb/get-fb-adapter";

const logger = consoleLogger.getPrefixedCopy('CMD_GET_FACEBOOK_ACCESS_TOKEN');

export class GetFacebookAccessTokenHandler {
    public async handle(): Promise<void> {
        try {
            const fbAdapter = getFbAdapter();
            fbAdapter.initSdk();

            const hasLoginState = await fbAdapter.getIsLoggedIn();
            if (!hasLoginState) {
                const hasLogin = await fbAdapter.logIn();
                if (!hasLogin) {
                    throw new Error('Failed to login to Facebook');
                }
            }

            const fbAuthData = await fbAdapter.getAuthData();

            if (fbAuthData && fbAuthData.accessToken) {
                GameClient.getInstance().sendCommand(new SetFacebookAccessTokenCommand({
                    accessToken: fbAuthData.accessToken
                }));
            } else {
                throw new Error('Failed to obtain Facebook access token');
            }
        } catch (error) {
            logger.error(error);
            window.Sentry.captureException(error);

            GameClient.getInstance().sendCommand(new OnErrorCommand({
                error: error instanceof Error ? error.message : 'Unknown error',
                method: WebCommands.GET_FACEBOOK_ACCESS_TOKEN
            }));
        }
    }
}
